import * as Constants from "../../constants"
import axios from 'axios';
import ChaserIcon from '../../assets/img/icons-chaser/chaser.svg';
import { Icon, LatLng, Point } from 'leaflet';
import { LocationGeocode } from '../locationGeocode/LocationGeocode';

export interface Marker {
    position: LatLng;
    icon: any;
    cursor: string;
    zIndex: number;
    title: string;
    data: any;

}
export class StormChaserService {
    
    options;
    _lastData={};
    
    
    constructor() {
        this.options = {
            chaser: <any>0,
        }
        if (typeof chaser !== 'undefined') {
            this.options.chaser = chaser;
        }
    }
    
    async getData() {
        try {
            const response = await axios.get(Constants.STORM_CHASER_API_URL + '?hiload=2' ?? '');
            if (response.status === 200 && response.data) {
                let data = response.data;
                if (typeof data === 'string') {
                    data = JSON.parse(atob(data))
                }
                if (data) {
                    this._lastData = data
                    return this.getStormChasers(data);
                }
            }
            return []
        } catch (e) {
            console.error(e);
            return []
        }
    }

    getStormChasers(data: any[]): Marker[] {
        const markers: Marker[] = [];
        if(Array.isArray(data) && data.length > 0) {
            data.forEach((item) => {
               const marker = this.getMarker(item);
               if (marker) {
                   markers.push(marker);
               }
            })
            
        }
        return markers;
    }
    getMarker(data: any): Marker | null {
        if (!this.options.chaser || this.options.chaser == 0 || (this.options.chaser.indexOf(data.User.UserName) != -1)) {
            const activeIcon = new Icon({
                iconUrl: ChaserIcon,
                iconSize: [66, 66],
                iconAnchor:  new Point(16, 16),
            });
            const icon = new Icon({
                iconUrl: ChaserIcon,
                iconSize:  data.IsStreaming ? [66, 66] : [66, 66],
                iconAnchor:  data.IsStreaming ? new Point (13, 10): new Point (9, 7),
            });
            
            
            return {
                position: new LatLng(data.Latitude, data.Longitude),
                icon: data.IsStreaming ? activeIcon : icon,
                data : data,
                cursor: 'hand',
                zIndex: 21,
                title: data.User.FirstName.charAt(0).toUpperCase() + data.User.FirstName.slice(1) + ' ' + data.User.LastName.charAt(0).toUpperCase() + data.User.LastName.slice(1)
            }
        }
        return null;
    }
    
    getViewersCount(data: any){
        let numberViewers = data.Viewers;
        if (numberViewers == 0) numberViewers = 1;
        return numberViewers
    }
    
    async getAddressData(data: any, key: string|null) {
        const geocode = new LocationGeocode();
        const resData = await geocode.reverseStadia(data.Latitude, data.Longitude, key);
        return resData ? resData : '';
    }
    
    
}


